import Image from "@/shared/components/Image/new";
import styles from "./styles.module.css";
import { formatAuthorNames } from '@/shared/functions/formatAthorNames';
import { EnVivo } from "@/shared/components/enVivo";

const NotasDePortadaHorizontal = (props) => {
    const CLIPPING = "3_2_300x200";
    const { content } = props;

    return (
        <div className={styles.parent}>
            {content &&
                content.map((element, index) => {
                    const { subtitle, url, id, title, authors, metadata } = element;

                    if (element.images && element.images[0]?.value) {
                        element = {
                            images: [
                                {
                                    clippings: element.images[0].value.clippings || [],
                                    title: element.images[0].value.title || "",
                                    _id: element.images[0]._id,
                                },
                            ],
                        };
                    }

                    let authorsList = [];
                    if (authors && authors.length) {
                        const authorName = formatAuthorNames(authors[0].name);
                        authors.length > 1
                            ? authors.slice(0, 2).forEach(a => {
                                const name = formatAuthorNames(a.name);
                                authorsList.push(
                                    a.slug ? `<a href="/autor/${a.slug}">${name}</a>` : name
                                );
                            })
                            : authorsList.push(
                                authors[0].slug
                                    ? `<a href="/autor/${authors[0].slug}">${authorName}</a>`
                                    : authorName
                            );
                    }

                    const parsedAuthors = authorsList.join(' - ');

                    const extraClass =
                        content.length === 4 && [1, 2, 3].includes(index)
                            ? styles["grid-listado-mobile"]
                            : "";

                    return (
                        <div
                            key={'NotasDePortada' + id + index}
                            className={`${styles["grid-item"]} ${extraClass}`}
                        >
                                <div className={styles["nota-link"]}>
                                    {metadata?.sponsored ? (
                                        <div className={styles.sponsored}>
                                            <a href={url}>
                                                <Image
                                                    element={element}
                                                    clipping={CLIPPING}
                                                    width={300}
                                                    height={200}
                                                    className={styles.img}
                                                />
                                            </a>
                                            <span className={styles.badge}>
                                                patrocinado
                                            </span>
                                        </div>
                                    ) : (
                                        <div className={styles["img-container"]}>
                                            <a href={url}>
                                                <Image
                                                    element={element}
                                                    clipping={CLIPPING}
                                                    width={300}
                                                    height={200}
                                                    className={styles.img}
                                                    />
                                            </a>
                                            {metadata?.typeWeb === "live_blog" && <EnVivo />}
                                        </div>
                                    )}

                                    <div className={styles["i-c"]}>
                                        <h2>
                                            <a href={url} style={{ textDecoration: 'none', color: 'inherit' }}>
                                                <div className={styles["blue-txt"]}>
                                                    {subtitle}{" "}
                                                </div>
                                                {title}
                                            </a>
                                        </h2>

                                        {parsedAuthors && (
                                            <div
                                                className={styles["note-author"]}
                                                dangerouslySetInnerHTML={{
                                                    __html: 'Por ' + parsedAuthors
                                                }}
                                            />
                                        )}
                                    </div>
                                </div>
                        </div>
                    );
                })}
        </div>
    );
};

export default NotasDePortadaHorizontal;
